<template>
  <el-main>
    <hic-table :condition="condition" :entities="myEntities" @load="page" :no-merge-fields="['医嘱内容']" @selection-change="selectionChange" :loading="meta.loading">
      <el-table-column align="center" width="10"><!--这列用颜色标记组数据--></el-table-column>
      <el-table-column v-if="!readonly" align="center" type="selection" :selectable="selectable" width="55"></el-table-column>
      <el-table-column v-if="!readonly" align="center" width="150px" label="操作">
        <template slot-scope="{ row }">
          <el-button v-if="!row.id" size="mini" type="danger" icon="el-icon-close" title="取消" plain circle :loading="row.saving" @click="optionCancel" />
          <el-button v-if="!row.id" size="mini" type="primary" icon="el-icon-check" title="保存" plain circle @click="adviceSave(row)" />
          <template v-if="row.id">
            <el-button v-if="!dftAction(row)" size="mini" type="default" plain round disabled>{{ row.no }}<br /><br /></el-button>
            <!-- <small v-if="!dftAction(row)" class="primary">{{ row.no }}</small> -->
            <el-dropdown v-else @command="(e) => action(e, row)" placement="bottom">
              <el-button :type="dftAction(row).type" size="mini" @click="action(dftAction(row).cmd, row)" plain round :style="`border-bottom: 5px solid ${dftAction(row).color}`">
                <span>{{ row.no }}</span>
                <br />
                <b>{{ dftAction(row).action }}</b>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item command="下达" v-if="row.state == '草稿' || row.state == '退回'" icon="el-icon-smoking" class="primary">下达</el-dropdown-item> -->
                <el-dropdown-item command="作废" v-if="row.state == '草稿' || row.state == '退回'" icon="el-icon-no-smoking" class="danger">作废</el-dropdown-item>
                <!-- <el-dropdown-item command="指示停止" v-if="row.state == '启用'" icon="el-icon-switch-button" class="danger">停止</el-dropdown-item> -->
                <el-dropdown-item command="暂停" v-if="!setting.hidePause && row.state == '启用'" icon="el-icon-video-pause" class="warning">暂停</el-dropdown-item>
                <el-dropdown-item command="取消" v-if="row.state == '启用' && !row.execTime" icon="el-icon-no-smoking" class="danger">取消</el-dropdown-item>
                <!-- <el-dropdown-item command="重启" v-if="row.state == '暂停'" icon="el-icon-video-play" class="primary">启用</el-dropdown-item> -->
                <!-- <el-dropdown-item command="delete" v-if="row.state == '废弃'" icon="el-icon-delete" class="danger">删除</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </template>
      </el-table-column>

      <el-table-column :filters="dictEnum.AdviceState" :filtered-value="filterStates" column-key="states" align="center" width="100" label="状态" prop="state">
        <template slot-scope="{ row }">
          <span v-if="!row.id" class="info">{{ row.state }}</span>
          <el-button v-else-if="row.state == '启用'" type="success" size="mini" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '待校对'" type="warning" size="mini" @click="showLogs(row)" plain>{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '待停止'" type="danger" size="mini" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '草稿'" type="primary" size="mini" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '废弃'" type="info" size="mini" @click="showLogs(row)" plain>{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '退回'" type="danger" size="mini" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else type="info" size="mini" @click="showLogs(row)">{{ row.state }}</el-button>
        </template>
      </el-table-column>

      <el-table-column :filters="dictEnum.AdviceType" :filter-multiple="false" column-key="type" align="center" width="100" label="类型" prop="type">
        <template slot-scope="{ row }">
          <el-select v-if="!row.id" :disabled="!!row.name" v-model="row.type" @change="clearOption" size="small">
            <el-option label="自动" value="自动" />
            <el-option label="药品" value="药品" />
            <el-option label="医技" value="医技" />
            <el-option label="嘱托" value="嘱托" />
          </el-select>
          <div v-else>
            <el-tag v-if="row.type == '药品'" type="primary" size="small" hit effect="plain">{{ row.type }}</el-tag>
            <el-tag v-else-if="row.type == '草药'" type="warning" size="small" hit effect="plain">{{ row.type }}</el-tag>
            <el-tag v-else-if="row.type == '医技'" type="danger" size="small" hit effect="plain">{{ row.type }}</el-tag>
            <el-tag v-else-if="row.type == '嘱托'" type="info" hit size="small">{{ row.type }}</el-tag>
            <el-tag v-else type="danger" effect="light" hit size="small">{{ row.type }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column :filters="setting.isSimple ? [] : dictEnum.AdviceTerm" :filter-multiple="false" column-key="term" align="center" width="100" label="期效" prop="term">
        <template #default="{ row }">
          <hic-dict-selector v-if="isEdit(row) && row.type != '离院' && row.type != '转科'" dict-type="AdviceTerm" is-enum v-model="row.term" @change="(e) => partChanged(e, row, 'term')" />
          <div v-else>
            <el-tag v-if="row.term == '长期'" type="success" size="small" hit>{{ row.term }}</el-tag>
            <el-tag v-else-if="row.term == '临时'" type="danger" size="small" hit>{{ row.term }}</el-tag>
            <el-tag v-else type="warning" size="small" hit>{{ row.term }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="" width="600" label="医嘱内容" prop="name">
        <template #default="{ row }">
          <template v-if="row.name">
            <editorDrug v-if="row.type == '药品'" :row="row" @partChange="partChanged" @ok="adviceSave" :storehouse-code="storehouseCode" />
            <editorMl v-else-if="row.type == '医技'" :row="row" :readonly="row.state !== '草稿' && row.state !== '退回'" @saveAdvice="partSave" @addnew="adviceSave"> </editorMl>
            <editorHerbal v-else-if="row.type == '草药'" :row="row" :readonly="row.state !== '草稿' && row.state !== '退回'" @init="page"></editorHerbal>
            <el-input v-else-if="row.type == '嘱托' && isEdit(row)" class="" v-model="row.name" maxlength="500" placeholder="请输入" size="small" clearable @change="partSave(row, { id: row.id, name: row.name })"></el-input>
            <div v-else-if="row.type == '转科' || row.type == '离院'">
              <el-tag type="danger" hit style="border-left: 3rem solid #ff4949">
                <span style="margin-left: -3rem; color: white">{{ row.type }}</span>
                <span style="margin-left: 1.5rem">{{ row.content }}</span>
              </el-tag>
            </div>
            <b v-else>{{ row.name }}</b>
          </template>
          <el-input v-else-if="row.type == '嘱托'" v-model="row.name" maxlength="500" placeholder="请输入" size="small" clearable @change="adviceSave(row)"></el-input>
          <el-select v-else ref="draftInput" allow-create :popper-append-to-body="false" @change="(val) => optionSelected(val, row)" style="width: 100%" size="small" v-model="options.selected" filterable placeholder="请选择" remote :filter-method="optionSearch" value-key="code" default-first-option>
            <!-- <el-option value="" disabled>
                <el-row style="width: 50rem; font-size: 15px" :gutter="16">
                  <el-col :span="4">名称</el-col>
                  <el-col :span="3">规格</el-col>
                  <el-col :span="3" class="right">单价</el-col>
                  <el-col :span="3" class="right">数量</el-col>
                  <el-col :span="2" class="center">单位</el-col>
                  <el-col :span="4">厂商</el-col>
                  <el-col :span="5" class="center">类别</el-col>
                </el-row>
              </el-option> -->
            <el-option v-for="item in options.issued" :key="item.id" :label="item.name" :value="item" style="font-size: 1rem; width: 50rem">
              <el-row v-if="item.adviceType == '药品' || item.adviceType == '草药'" :gutter="0" :title="`厂商：${item.manufacturerCode} 批次：${item.lotNumber || '无'} 有效期：${item.expirationDate}`">
                <el-col :span="1"><small class="primary">药品</small></el-col>
                <el-col :span="14" style="white-space: pre-line">
                  <span>{{ item.name }}</span>
                  <small>{{ item.standard }}</small>
                </el-col>
                <el-col :span="4" class="right danger">￥{{ item.price | fmtFloat }}</el-col>
                <el-col :span="3" class="left">
                  <span class="left-pad">{{ item.type | dictText("DrugType") }}</span>
                </el-col>
                <el-col :span="2" class="right primary">{{ item.quantity }} {{ item.unit }}</el-col>
              </el-row>
              <el-row v-else :gutter="0" :title="item.standard">
                <el-col :span="1"><small class="warning">医技</small></el-col>
                <el-col :span="14" style="white-space: pre-line">{{ item.name }}</el-col>
                <el-col :span="4" class="right danger">￥{{ item.price | fmtFloat }}</el-col>
                <el-col :span="3" class="left left-pad">{{ item.type | dictText("DrugType") }}</el-col>
                <el-col :span="2" class="center">{{ item.insuranceClass | dictText("ReimbursCategory") }}</el-col>
              </el-row>
            </el-option>
            <el-option v-for="item in options.drug" :key="item.id" :label="item.name" :value="item" style="font-size: 1rem; width: 50rem">
              <el-row :gutter="0" :title="`厂商：${item.manufacturerCode} 批次：${item.lotNumber || '无'} 有效期：${item.expirationDate}`">
                <el-col :span="1"><small class="primary">药品</small></el-col>
                <el-col :span="14" style="white-space: pre-line">
                  <span>{{ item.name }}</span>
                  <small>{{ item.standard }}</small>
                </el-col>
                <el-col :span="4" class="right danger">￥{{ item.price | fmtFloat }}</el-col>
                <el-col :span="3" class="left">
                  <span class="left-pad">{{ item.type | dictText("DrugType") }}</span>
                </el-col>
                <el-col :span="2" class="right primary">{{ item.quantity }} {{ item.unit }}</el-col>
              </el-row>
            </el-option>
            <!-- <el-option value="" disabled>
                <el-row style="width: 50rem; font-size: 15px" :gutter="16">
                  <el-col :span="4">类型</el-col>
                  <el-col :span="4">名称</el-col>
                  <el-col :span="3">医保类别</el-col>
                  <el-col :span="3" class="right">价格（元）</el-col>
                </el-row>
              </el-option> -->
            <el-option v-for="item in options.ml" :key="item.id" :label="item.name" :value="item" style="font-size: 1rem; width: 50rem">
              <el-row :gutter="0" :title="item.standard">
                <el-col :span="1"><small class="warning">医技</small></el-col>
                <el-col :span="14" style="white-space: pre-line">{{ item.name }}</el-col>
                <el-col :span="4" class="right danger">￥{{ item.price | fmtFloat }}</el-col>
                <el-col :span="3" class="left left-pad">{{ item.type | dictText("DrugType") }}</el-col>
                <el-col :span="2" class="center">{{ item.insuranceClass | dictText("ReimbursCategory") }}</el-col>
              </el-row>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" align="center" width="220" label="开始时间" prop="startTime">
        <template #default="{ row }">
          <el-date-picker v-if="isEdit(row)" type="datetime" v-model="row.startTime" @change="(e) => partChanged(e, row, 'startTime')" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 100%" placeholder="请选择"></el-date-picker>
          <span v-else>{{ row.startTime }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" align="center" width="150" label="停止时间" prop="endTime">
        <template #default="{ row }">
          <el-date-picker v-if="!setting.isSimple && isEdit(row)" type="date" v-model="row.endTime" @change="(e) => partChanged(e, row, 'endTime')" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 100%" placeholder="请选择"></el-date-picker>
          <span v-else>{{ row.stopTime | fmtDate }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="!setting.isSimple" :filters="dictEnum.InsuranceRange" :filter-multiple="false" column-key="claimType" align="center" width="120" label="医保范围" prop="claimType">
        <template #default="{ row }">
          <hic-dict-selector v-if="isEdit(row)" @change="(e) => partChanged(e, row, 'claimType')" dict-type="InsuranceRange" is-enum v-model="row.claimType" auto />
          <template v-else>
            <el-tag v-if="row.claimType == '医保外'" type="danger" hit size="small">{{ row.claimType }}</el-tag>
            <el-tag v-else-if="!!row.claimType" type="success" hit size="small">{{ row.claimType }}</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column v-if="!setting.isSimple" align="center" width="60" label="出院带药" prop="ifHomeDrug">
        <template #default="{ row }">
          <el-checkbox v-if="isEdit(row)" :disabled="row.term != '临时' || row.type != '药品'" :checked="row.ifHomeDrug" v-model="row.ifHomeDrug" @change="(e) => partChanged(e, row, 'ifHomeDrug')"></el-checkbox>
          <template v-else>
            <el-tag v-if="row.ifHomeDrug" type="danger" hit size="small">是</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column v-if="!setting.isSimple" align="center" width="60" label="长嘱临费" prop="ifOneTimeCharge">
        <template #default="{ row }">
          <el-checkbox v-if="isEdit(row)" :disabled="row.term == '临时' || row.type != '药品'" :checked="row.ifOneTimeCharge" v-model="row.ifOneTimeCharge" @change="(e) => partChanged(e, row, 'ifOneTimeCharge')"></el-checkbox>
          <div v-else>
            <el-tag v-if="row.ifOneTimeCharge" type="danger" hit size="small">是</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="!setting.isSimple" align="center" width="60" label="备用" prop="ifStandby">
        <template #default="{ row }">
          <el-checkbox v-if="isEdit(row)" :checked="row.ifStandby" v-model="row.ifStandby" @change="(e) => partChanged(e, row, 'ifStandby')"></el-checkbox>
          <div v-else>
            <el-tag v-if="row.ifStandby" type="danger" hit size="small">是</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" width="160" label="嘱托" prop="content">
        <template #default="{ row }">
          <el-input v-if="isEdit(row)" class="" @blur="(e) => partChanged(row.content, row, 'content')" v-model="row.content" maxlength="500" placeholder="请输入" size="small" clearable></el-input>
          <div v-else>{{ row.content }}</div>
        </template>
      </el-table-column>

      <el-table-column v-if="!setting.isSimple" align="center" width="150" label="执行科室" prop="">
        <template #default="{ row }">
          <hic-dict-selector v-if="isEdit(row)" dict-type="Dept" @change="(e) => partChanged(e, row, 'execDeptCode')" class="f-w" v-model="row.execDeptCode" />
          <div v-else>{{ row.execDeptCode | dictText("Dept") }}</div>
        </template>
      </el-table-column>

      <el-table-column align="center" width="100" label="开嘱医师" prop="doctorName"></el-table-column>
      <el-table-column align="center" width="100" label="校对护士" prop="issuedNurseName"></el-table-column>
      <el-table-column align="center" width="100" label="停嘱医师" prop="stopDoctorName"></el-table-column>
      <el-table-column align="center" width="100" label="停嘱护士" prop="stopNurseName"></el-table-column>
      <el-table-column :filters="dictEnum.RpClass" :filter-multiple="false" column-key="rpClass" align="center" width="100" label="处方类型" prop="rpClass"></el-table-column>
    </hic-table>
    <LogDialog :visible.sync="meta.logShow" :advice="curr" isBack @back="onBack" />
  </el-main>
</template>
<script>
  import { readonly } from "vue";
  import api from "../api";
  import { mapGetters } from "sw-hic";

  export default {
    props: {
      storehouseCode: String,
      condition: Object,
      readonly: Boolean,
    },
    components: {
      editorDrug: () => import("./_editorDrug"),
      editorMl: () => import("./_editorMl"),
      editorHerbal: () => import("./_editorHerbal"),
      LogDialog: () => import("./dlgLog"),
    },
    data() {
      return {
        filterStates: ["草稿", "待校对", "退回", "启用", "停止", "待停止"],
        options: {
          issued: [],
          drug: [],
          ml: [],
          selected: null,
        },
        entities: {},
        meta: {
          loading: false,
          logShow: false,
        },
        curr: null,
        selection: [],
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "user", "permission", "setting"]),
      myEntities() {
        let items = this.readonly ? [] : [this.proto()];
        if (!this.entities) {
          return { items };
        }
        if (!this.entities.items) {
          return { ...this.entities, items };
        }
        items.push(...this.entities.items);
        return { ...this.entities, items };
      },
    },
    mounted() {
      this.page();
    },
    inject: ["proto"], // 注入父类方法
    methods: {
      page() {
        if (!this.condition.hospitalizationId) {
          return;
        }
        this.meta.loading = true;
        if (!this.condition.states || !this.condition.states.length) {
          this.condition.states = this.filterStates;
        }
        console.log('======医嘱请求条件=====',this.condition)
        api.Advice.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
            this.$nextTick(() => {
              if (this.$refs.draftInput) {
                this.$refs.draftInput.focus();
              }
            });
          });
      },
      refresh(ids) {
        if (!ids) {
          this.condition.pageIndexOnView = 1;
          this.page();
          return;
        }
        api.Advice.query({ ids }).then((res) => {
          res.items.forEach((row) => {
            let e = this.entities.items.find((e) => e.id == row.id);
            if (e) {
              e.state = row.state;
              e.lockKey = row.lockKey;
            } else {
              this.entities.items.unshift(row);
            }
          });
        });
      },
      isEdit(row) {
        return !row.id || row.state == "草稿" || row.state == "退回";
      },
      selectionChange(val) {
        this.selection = val;
      },
      relieveGroup(item) {
        this.$confirm("确定要解除成组？", "警告", { type: "warning" })
          .then(() => {
            this.meta.loading = true;
            api.Advice.delGroup(item.id)
              .then((res) => {
                this.$emit("refresh");
              })
              .catch((err) => {
                this.$message.error(err.message || err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          })
          .catch((e) => {});
      },
      copyAdvice(item) {
        this.$confirm("确定要复制该医嘱？", "警告", { type: "warning" })
          .then(() => {
            api.Advice.copy(item.id)
              .then((res) => {
                this.meta.loading = false;
                this.$emit("refresh");
              })
              .catch((err) => {
                this.$message.error(err.message || err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          })
          .catch((e) => {});
      },
      optionSearch(keyword) {
        let maxLength = 30;
        let draft = this.myEntities.items[0];
        if (!keyword) return;
        if (draft.type == "自动") {
          api.AdviceIssued.query({ pageSize: maxLength, keyword, createUserId: this.user.id}).then((res) => {
            let issuedAll = res.items;
            let issuedDrugs = issuedAll.filter(item => item.adviceType == '药品' || item.adviceType == '草药');
            let issuedMls = issuedAll.filter(item => item.adviceType == '医技');
            this.options.issued = res.items.map(item => {
              let detail = JSON.parse(item.detail);
              detail.adviceType = item.adviceType;

              return detail;
            });

            api.Drug.getDrugs({ pageSize: maxLength + issuedDrugs.length, keyword, storehouseCode: this.storehouseCode, sort: "sortNum" }).then((res) => {
              if (issuedDrugs.length) {
                this.options.drug = res.items.filter(item => {
                  let drug = issuedDrugs.find(d => d.storehouseCode == item.storehouseCode && d.code == item.code);

                  return !drug;
                });
              } else {
                this.options.drug = res.items;
              }
              this.options.drug = this.options.drug.slice(0, maxLength);

              return api.Ml.query({ keyword, pageSize: maxLength + issuedMls.length }).then((res) => {
                if (issuedMls.length) {
                  this.options.ml = res.items.filter(item => {
                    let ml = issuedMls.find(m => m.rpClass == item.rpClass && m.code == item.code);

                    return !ml;
                  });
                } else {
                  this.options.ml = res.items;
                }
                this.options.ml = this.options.ml.slice(0, maxLength);
              });
            });
          });
        } else if (draft.type == "药品") {
          api.AdviceIssued.query({ pageSize: maxLength, keyword, createUserId: this.user.id, adviceTypes: [ '药品', '草药'] }).then((res) => {
            let issuedAll = res.items;
            this.options.issued = res.items.map(item => {
              let detail = JSON.parse(item.detail);
              detail.adviceType = item.adviceType;

              return detail;
            });

            api.Drug.getDrugs({ pageSize: maxLength + issuedAll.length, keyword, storehouseCode: this.storehouseCode, sort: "sortNum" }).then((res) => {
              if (issuedAll.length) {
                this.options.drug = res.items.filter(item => {
                  let drug = issuedAll.find(d => d.storehouseCode == item.storehouseCode && d.code == item.code);

                  return !drug;
                });
              } else {
                this.options.drug = res.items;
              }
              this.options.drug = this.options.drug.slice(0, maxLength);
            });
          });
        } else if (draft.type == "医技") {
          api.AdviceIssued.query({ pageSize: maxLength, keyword, createUserId: this.user.id, adviceType: '医技' }).then((res) => {
            let issuedAll = res.items;
            this.options.issued = res.items.map(item => {
              let detail = JSON.parse(item.detail);
              detail.adviceType = item.adviceType;

              return detail;
            });

            api.Ml.query({ keyword, pageSize: maxLength + issuedAll.length }).then((res) => {
              if (issuedAll.length) {
                this.options.ml = res.items.filter(item => {
                  let ml = issuedAll.find(m => m.rpClass == item.rpClass && m.code == item.code);

                  return !ml;
                });
              } else {
                this.options.ml = res.items;
              }
              this.options.ml = this.options.ml.slice(0, maxLength);
            });
          });
        }
      },
      optionSelected(option, draft) {
        if (typeof option == "string") {
          this.$set(draft, "name", option);
          this.$set(draft, "type", "嘱托");
          return;
        }
        // if (option.storehouseCode && option.restrict) {
        //   if ((this.user.drugRestrict || []).findIndex((r) => r.code == option.restrict) < 0) {
        //     return this.$message.error("您暂时无权限开具此药品！");
        //   }
        // }
        
        this.$utils.Obj.propertyCopy(
          option,
          draft,
          [
            "rpClass",
            "code",
            "insuranceCode",
            "claimType",
            "name",
            "standard",
            "unit",
            "quantity",
            "approvalNumber",
            "lotNumber",
            "form",
            "manufacturerCode",
            "feeType",
            "restrict",
            "cost",
            "price",
            "frequency",
            "times",
            "dosagePerTime",
            "dosageUnit",
            "totalDose",
            "usage",
            "drops",
            "itemType",
            "symptom",
            "parts",
            "checkWays",
            "execDeptCode",
            "content",
            "ifHomeDrug",
            "ifOneTimeCharge",
            "ifStandby",
            "decoction",
            "dosage",
            "contraindication",
            "specialUsage",
            "purpose",
            "ifEmergency",
            "specimenType",
            "storehouseCode",
          ],
          this
        );
        if(option.type == 0) this.$set(draft, "feeType", "07") //西药
        else if(option.type == 1) this.$set(draft, "feeType", "09") //中成药
        else if(option.type == 2) this.$set(draft, "feeType", "08") //中草药

        this.$set(draft, "detail", JSON.stringify(option));
        this.$set(draft, "id", null);
        if (option.storehouseCode) {
          this.$set(draft, "type", "药品");
          this.$set(draft, "rpClass", "药品");
          this.$set(draft, "usage", option.usage);
          this.$set(draft, "quantity", 1);
          this.$set(draft, "dosagePerTime", option.dosages);
          this.$set(draft, "srcId", option.id); // 库存ID
        } else {
          this.$set(draft, "type", "医技");
        }
      },
      optionCancel() {
        this.options.curr = null;
        this.$set(this.myEntities.items, 0, this.proto());
      },
      adviceSave(row) {
        // 此处只处理医嘱主记录
        if (!row.name) {
          return this.$message.error("请录入医嘱内容，医嘱内容不能为空!");
        }
        this.$emit("save", row);
        this.clearOption();
      },
      partChanged(val, row, key, obj) {
        this.$utils.log(val, row, key, obj);
        // 局部修改
        if (!row.id) {
          return;
        }
        if (obj) {
          this.partSave(row, obj);
          return;
        }
        this.$nextTick(() => {
          let obj = { id: row.id };
          obj[key] = val;
          this.partSave(row, obj);
        });
      },
      partSave(item, val) {
        // 局部更新
        if (!item.id || !item.name) {
          return;
        }
        let rows = [item];
        if (item.groupNo && (val.usage || val.frequency || val.cycles || val.drops || val.times || val.dailyTime)) {
          rows = this.myEntities.items.filter((i) => i.groupNo == item.groupNo);
        }
        rows.forEach((row) => {
          val.id = row.id;
          if (val.usage || val.frequency || val.cycles || val.drops) {
            this.$utils.Obj.propertyCopy(item, row, ["usage", "frequency", "cycles", "drops", "times", "dailyTime"]);
          }
          api.Advice.patch(val)
            .then((res) => {
              row.lockKey = res.lockKey;
            })
            .catch((err) => {
              console.log(err);
            });
        });
      },

      showLogs(row) {
        if (row.singleOrMaster) {
          this.curr = row;
        } else {
          this.curr = this.myEntities.items.find((el) => el.id == row.groupNo);
        }
        this.meta.logShow = true;
      },
      action(cmd, row) {
        if (cmd == "delete") {
          this.$confirm("此操作不可后退，删除后无法恢复，确认要删除这条医嘱吗？", "删除确认", { type: "warning" })
            .then((res) => {
              api.Advice.del(row.groupNo || row.id)
                .then((res) => {
                  this.$message.success("删除成功");
                  this.page();
                  this.$emit("deleted", row);
                })
                .catch((err) => {
                  this.$message.error(err.message || err);
                });
            })
            .catch(() => {});
          return;
        }
        this.$emit("action", cmd, [row.groupNo || row.id]);
      },
      dftAction(row) {
        if (row.state == "草稿" || row.state == "退回") {
          return { action: "下 达", cmd: "下达", type: "primary", color: "#409EFF" };
        }
        if (row.state == "废弃") {
          return { action: "删 除", cmd: "delete", type: "danger", color: "#F56C6C" };
        }
        if (row.state == "启用") {
          return { action: "停 止", cmd: "指示停止", type: "danger", color: "#F56C6C" };
        }
        if (row.state == "暂停") {
          return { action: "启 用", cmd: "重启", type: "primary", color: "#409EFF" };
        }
        return null;
      },
      selectable(row) {
        if (!row.id) {
          return false;
        }
        return true;
      },
      onBack(row) {
        this.refresh([row.id]);
      },
      clearOption() {
        this.options.issued = [];
        this.options.drug = [];
        this.options.ml = [];
        this.options.selected = null;
      },
    },
  };
</script>
<style scoped>
  /deep/ .el-table .row-expand-cover .cell .el-table__expand-icon {
    display: none;
  }

  /deep/ .el-table .groupColor {
    background-color: aqua;
    /* color:#fff; */
  }
  .advieGrp0 {
    border-left: 10px solid gold;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp1 {
    border-left: 10px solid cyan;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp2 {
    border-left: 10px solid salmon;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp3 {
    border-left: 10px solid cornflowerblue;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp4 {
    border-left: 10px solid greenyellow;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp5 {
    border-left: 10px solid skyblue;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp6 {
    border-left: 10px solid pink;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp7 {
    border-left: 10px solid khaki;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp8 {
    border-left: 10px solid powderblue;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp9 {
    border-left: 10px solid moccasin;
    /* border-right: 1px solid goldenrod; */
  }
</style>
